{
  "name": "@notifi-network/notifi-react",
  "version": "7.6.0",
  "description": "React components to access Notifi core services",
  "keywords": [
    "notifi",
    "react",
    "web3",
    "blockchain",
    "notification"
  ],
  "author": "eric-notifi <eric.lee@notifi.network>",
  "homepage": "https://github.com/notifi-network/notifi-sdk-ts#readme",
  "license": "MIT",
  "main": "./dist/index.js",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./dist/index.css": "./dist/index.css"
  },
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/notifi-network/notifi-sdk-ts.git"
  },
  "scripts": {
    "build": "npm run clean && npm run compile",
    "clean": "rimraf ./dist",
    "compile": "tsup lib/index.ts --sourcemap --format cjs,esm --dts --clean --external react",
    "format": "prettier --config .prettierrc **/*.ts --write",
    "lint": "eslint .",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@notifi-network/notifi-frontend-client": "^7.6.0",
    "clsx": "^1.2.1",
    "date-fns": "^2.29.3",
    "dompurify": "^3.0.5",
    "libphonenumber-js": "^1.10.13"
  },
  "devDependencies": {
    "@types/marked": "^5.0.1"
  },
  "peerDependencies": {
    "react": "^18"
  },
  "engines": {
    "node": ">=20.18.0"
  },
  "tsup": {
    "noExternal": [
      "libphonenumber-js"
    ]
  },
  "gitHead": "13954c2bcaf5d11052cbb0ce6fe5e3b36a131757"
}
